import {
  Clock,
  AlertCircle,
  CreditCard,
  Plus,
  Copy,
  ArrowLeft
} from "lucide-react";
import { Link, useNavigate, useParams } from "react-router-dom";
import DashboardLayout from "../../components/layouts/DashboardLayout";
import { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL, SERVER_URL } from "../../utils/config";
import { message } from "../../utils/toast";
import _ from "lodash";
import dateformat from "dateformat";
import { Button } from "../../components/ui/Button";
import copy from "copy-to-clipboard";

const statusConfig = {
  started_trial: {
    icon: Clock,
    text: "Started Trial",
    className: "bg-blue-50 text-blue-700"
  },
  requires_followup: {
    icon: AlertCircle,
    text: "Requires Followup",
    className: "bg-yellow-50 text-yellow-700"
  },
  paid: {
    icon: CreditCard,
    text: "Paid",
    className: "bg-green-50 text-green-700"
  }
};

const LeadsTablePage = () => {
  const { id: campaignId } = useParams();
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${SERVER_URL}/api/lead?campaign_id=${campaignId}`)
      .then(({ data }) => {
        setLeads(data);
      })
      .catch((error) => {
        message({ type: "error", content: error.message });
      });
  }, [campaignId]);

  const copyLink = (leadId) => {
    const link = `${BASE_URL}/profile_preview/${leadId}`;
    copy(link);
    message({ type: "success", content: "Link copied" });
  };

  return (
    <DashboardLayout>
      <div className="p-8">
        <div className="flex justify-between items-center mb-8 max-md:block">
          <div className="max-md:mb-4">
            <Link
              to="/campaigns-list"
              className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
            >
              <ArrowLeft size={20} />
              <span>Back to Campaigns</span>
            </Link>
            <h1 className="text-2xl font-bold text-gray-900">Campaign Leads</h1>
            <p className="text-gray-600">
              Manage and track leads for this campaign
            </p>
          </div>
          <Link
            to={`/campaigns-list/${campaignId}/add-lead`}
            className="inline-flex items-center gap-2 bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 max-md:flex max-md:justify-center"
          >
            <Plus size={20} />
            Add Lead
          </Link>
        </div>

        <div className="bg-white rounded-lg shadow-sm overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Lead
                </th>
                {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Email
                </th> */}
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Status
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Date Added
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Copy Link
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {_.map(leads, (lead) => {
                const status = statusConfig["started_trial"];
                const StatusIcon = status.icon;

                return (
                  <tr key={lead.id} className="cursor-pointer">
                    <td
                      className="px-6 py-4 whitespace-nowrap"
                      onClick={() =>
                        navigate(
                          `/campaign-list/${campaignId}/leads/${lead.id}`
                        )
                      }
                    >
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10">
                          <img
                            className="h-10 w-10 rounded-full object-cover"
                            src={lead.file_url}
                            alt={`/`}
                          />
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">
                            {lead.lead_name}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td
                      className="px-6 py-4 whitespace-nowrap"
                      onClick={() =>
                        navigate(
                          `/campaign-list/${campaignId}/leads/${lead.id}`
                        )
                      }
                    >
                      <span
                        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-medium ${status.className}`}
                      >
                        <StatusIcon size={14} />
                        {status.text}
                      </span>
                    </td>
                    <td
                      className="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      onClick={() =>
                        navigate(
                          `/campaign-list/${campaignId}/leads/${lead.id}`
                        )
                      }
                    >
                      {dateformat(lead.created_at, "mmm dd, yyyy")}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                      <Button onClick={() => copyLink(lead.id)}>
                        <Copy />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default LeadsTablePage;
